import { useEffect, useRef } from 'react'
import Pusher from 'pusher-js'

function getWsConfig() {
  const hostname = window.location.hostname

  if (hostname.endsWith('.sispoli.com.br')) {
    return {
      key: 'sispoli-ws-prod-key-205e2bce05b3496e',
      wsHost: 'ws.sispoli.com.br',
      wsPort: 443,
      wssPort: 443,
      forceTLS: true,
    }
  }

  return {
    key: 'sispoli-ws-key',
    wsHost: hostname === 'localhost' ? 'localhost' : 'ws.sispoli.local',
    wsPort: 6001,
    wssPort: 6001,
    forceTLS: false,
  }
}

let pusherInstance: Pusher | null = null

function getPusher(): Pusher {
  if (pusherInstance) return pusherInstance

  const config = getWsConfig()
  pusherInstance = new Pusher(config.key, {
    wsHost: config.wsHost,
    wsPort: config.wsPort,
    wssPort: config.wssPort,
    forceTLS: config.forceTLS,
    enabledTransports: ['ws', 'wss'],
    disableStats: true,
    cluster: 'mt1',
  })

  return pusherInstance
}

export default function usePusherChannel(
  channelName: string | null,
  eventName: string,
  callback: (data: any) => void,
) {
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  useEffect(() => {
    if (!channelName) return

    const pusher = getPusher()
    const channel = pusher.subscribe(channelName)
    channel.bind(eventName, (data: any) => { callbackRef.current(data) })

    return () => {
      channel.unbind(eventName)
      pusher.unsubscribe(channelName)
    }
  }, [channelName, eventName])
}
